export default function HeroSection() {
  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[700px] flex items-center pt-[72px] overflow-hidden"
    >
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20cinematic%20abstract%20atmosphere%20with%20soft%20amber%20golden%20light%20gradients%2C%20dark%20theater%20curtain%20texture%20at%20edges%2C%20subtle%20film%20grain%2C%20elegant%20warm%20lighting%2C%20dreamy%20night%20cinema%20mood%2C%20rich%20deep%20brown%20and%20gold%20tones%2C%20luxurious%20theater%20ambiance%2C%20soft%20bokeh%20lights%2C%20no%20text%2C%20abstract%20artistic%20style%2C%20clean%20composition&width=1600&height=900&seq=hero-bg-2026-x1&orientation=landscape"
          alt="春夜影院氛围背景"
          className="w-full h-full object-cover object-center"
          loading="eager"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/40 to-black/60"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6">
        <div className="max-w-[1280px] mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16 py-12 md:py-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block text-xs md:text-sm font-medium text-primary-400 bg-primary-500/15 px-3 py-1.5 rounded-full mb-5 tracking-wider uppercase">
              春夜 · 光影盛宴
            </span>

            <h1 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-background-50 leading-tight mb-4">
              春夜影院 · 你的私人光影时光
            </h1>

            <p className="text-base md:text-lg text-background-200/90 leading-relaxed max-w-xl lg:max-w-none mb-2">
              沉浸于春夜的温柔光影之中，我们为你汇聚最新电影全集与电视剧大全。无论热播大片还是经典佳作，蓝光画质搭配流畅播放，无需等待缓冲，随时随地开启专属观影之旅。
            </p>
            <p className="text-sm md:text-base text-background-300/80 leading-relaxed max-w-xl lg:max-w-none mb-6">
              每日更新热门影视内容，覆盖电影、电视剧、综艺、动漫等全品类资源，让每一个夜晚都有一部好片相伴。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-5 md:gap-8 mb-8">
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading font-bold text-primary-400">20000+</div>
                <div className="text-xs md:text-sm text-background-300/80 mt-1">影视资源</div>
              </div>
              <div className="w-px h-10 bg-background-300/30 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading font-bold text-primary-400">每日更新</div>
                <div className="text-xs md:text-sm text-background-300/80 mt-1">新鲜片源</div>
              </div>
              <div className="w-px h-10 bg-background-300/30 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading font-bold text-primary-400">蓝光画质</div>
                <div className="text-xs md:text-sm text-background-300/80 mt-1">沉浸体验</div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#ranking"
                className="inline-flex items-center gap-2 bg-primary-500 hover:bg-primary-600 text-background-50 font-medium px-6 py-3 rounded-md transition-colors whitespace-nowrap cursor-pointer text-sm"
              >
                <i className="ri-fire-line text-lg"></i>
                查看热门榜单
              </a>
              <a
                href="#index"
                className="inline-flex items-center gap-2 border border-background-300/50 hover:border-background-200 text-background-50 font-medium px-6 py-3 rounded-md transition-colors whitespace-nowrap cursor-pointer text-sm"
              >
                <i className="ri-grid-line text-lg"></i>
                浏览分类索引
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-full max-w-[480px] aspect-[4/3] rounded-lg overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Elegant%20cinematic%20composition%20with%20vintage%20film%20projector%20casting%20warm%20golden%20light%2C%20floating%20film%20strips%2C%20soft%20theater%20curtain%20draping%2C%20rich%20amber%20and%20deep%20brown%20tones%2C%20artistic%20movie%20atmosphere%2C%20warm%20spotlight%20effect%2C%20luxurious%20gold%20accents%2C%20dreamy%20cinema%20aesthetic%2C%20no%20text%2C%20clean%20elegant%20style&width=960&height=720&seq=hero-visual-2026-x1&orientation=landscape"
                alt="春夜影院主题视觉"
                className="w-full h-full object-cover object-center rounded-lg"
              />
              <div className="absolute inset-0 rounded-lg bg-gradient-to-t from-black/30 to-transparent"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}